<template>
  <v-container fluid class="fill-height">
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" sm="9" md="6" lg="4">
        <v-card class="elevation-12">

           <!-- Language selection -->
          <div class="text-right pr-2 pt-2">
            <LanguageSelector />
          </div>

          <v-img
            :src="require('@/assets/LTOU_logo.png')"
            height="40"
            width="300"
            class="ma-auto"
            contain
          />

          <v-form ref="form" autocomplete="off" @submit.prevent="submit">
            <v-card-text>
              <h3 class="mb-4">{{ $t('forgot_password_title') }}</h3>

              <v-text-field
                v-model="email"
                :label="$t('username')"
                prepend-icon="mdi-email"
                type="email"
                autocomplete="off"
              />

              <div v-if="sent" class="mt-2">
                {{ $t('if_exists_email_sent') }}
              </div>
            </v-card-text>

            <v-card-actions class="px-4 pb-4">
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                type="submit"
                class="mr-2"
              >
                {{ $t('send_reset_link') }}
              </v-btn>

              <v-btn
                :disabled="loading"
                outlined
                color="primary"
                :to="{ name: 'login' }"
              >
                {{ $t('back_to_login') }}
              </v-btn>
            </v-card-actions>
          </v-form>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LanguageSelector from '@/components/LanguageSelector';
import authService from '@/api/auth-service';

export default {
  name: 'ForgotPassword',
  components: { LanguageSelector },
  data: () => ({
    email: '',
    loading: false,
    sent: false,
  }),
  methods: {
    async submit() {
      this.loading = true;
      try {
        await authService.forgotPassword(this.email);
        // Neutral response – we don't show if email exists
        this.sent = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>